<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import SummaryModelCard from '~/features/my-wallet/blocks/summary/SummaryModelCard.vue'
import SummarySkeleton from '~/features/my-wallet/blocks/summary/SummarySkeleton.vue'
import MyWalletNotImpersonate from '~/features/my-wallet/components/MyWalletNotImpersonate.vue'
import MyWalletStateGate from '~/features/my-wallet/components/MyWalletStateGate.vue'
import { useSummary } from '~/features/my-wallet/composables/useSummary'

interface Props {
  receivingModelTab: string
}

defineProps<Props>()

const { t } = useI18n()

const { screenState, displayData, handleRefresh, openImpersonateModal } = useSummary()
</script>

<template>
  <MyWalletNotImpersonate v-if="screenState === 'not_impersonating'" @open-impersonate="openImpersonateModal" />

  <section
    v-else
    class="summary"
    aria-labelledby="my-wallet-summary-title"
    :aria-busy="screenState === 'loading'"
  >
    <h3 id="my-wallet-summary-title" class="summary-title">
      {{ t('my_wallet.summary.title') }}
    </h3>

    <MyWalletStateGate
      :state="screenState"
      :data="displayData"
      error-id="my-wallet-summary-error"
      heading-tag="h4"
      @retry="handleRefresh"
    >
      <template #skeleton>
        <div class="summary-cards">
          <SummarySkeleton />
        </div>
      </template>

      <template #default="{ data: summary }">
        <div class="summary-cards">
          <SummaryModelCard :summary="summary" :details-tab="receivingModelTab" @retry="handleRefresh" />
        </div>
      </template>
    </MyWalletStateGate>
  </section>
</template>

<style scoped lang="scss">
.summary {
  @apply flex flex-col gap-6 w-full;

  .summary-title {
    @apply fonts-heading-h3 text-neutral-low-dark;
    line-height: 1.5;
  }

  .summary-cards {
    @apply grid grid-cols-1 gap-4;

    @screen md:system {
      @apply grid-cols-3;
    }
  }
}
</style>
